import { useEffect, useRef } from 'react';

// Channel name must match the one posted from routes/billing/checkout-success.tsx.
const CHECKOUT_CHANNEL = 'optidev-checkout';

export type CheckoutType = 'top-up' | 'cloud-add-funds';

/**
 * Listens for Stripe Checkout completion broadcast from the checkout-success page.
 * Fires `onSuccess` when a matching `type` message arrives (e.g. from the now-closed embed tab).
 */
export function useCheckoutSuccessListener(type: CheckoutType, onSuccess: () => void): void {
  const onSuccessRef = useRef(onSuccess);
  onSuccessRef.current = onSuccess;

  useEffect(() => {
    if (typeof BroadcastChannel === 'undefined') return;

    const channel = new BroadcastChannel(CHECKOUT_CHANNEL);
    channel.onmessage = (event: MessageEvent): void => {
      if (event.data?.type === type) {
        onSuccessRef.current();
      }
    };

    return () => channel.close();
  }, [type]);
}
